import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardActions from "@material-ui/core/CardActions";
import {labelBeagleHistoryCard} from "./LabelBeagleHistoryCard";
import BeagleHistoryCardTable from "./BeagleHistoryCardTable";
import IconButton from "@material-ui/core/IconButton";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ClearIcon from '@material-ui/icons/Clear';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from '@material-ui/lab/Alert';
import Tooltip from "@material-ui/core/Tooltip";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        maxWidth: 325,
    },
    rootNewCalc: {
        minWidth: 275,
        maxWidth: 325,
        backgroundColor: 'silver',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
        fontWeight: "bold",
    },
    pos: {
        marginBottom: 12,
    },
    buttonCopy: {
        float: "right",
    }
}));


export default function BeagleHistoryCard(props) {
    const classes = useStyles();

    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const handleCloseSnackbar = (event, reason) => {
        setOpenSnackbar(false);
    };


    let langPref = props.beagleLanguagePreference;
    let hideClearButton = props.hideClearButton;
    const labelClearButton = labelBeagleHistoryCard.labelClearButton[langPref];
    const labelCopyButton = labelBeagleHistoryCard.labelCopyToClipboardButton[langPref];
    const labelCopySnackBar = labelBeagleHistoryCard.labelCopyToClipboardSnackBar[langPref];

    const handleClearCalc = () => {
        props.removeBeagleCalculatorHistory(props.beagleCropCalculation);
    }

    function getClipboardTextRow(nutrientLabel, nutrientNumber) {
        if (nutrientNumber === undefined) {
            return '';
        }
        if (nutrientNumber === 0) {
            return '';
        }
        return nutrientLabel + '\t' + nutrientNumber + '\n';
    }


    function getClipboardContent() {

        return props.beagleCropCalculation.cropName[langPref] + '\t' +
            props.beagleCropCalculation.yieldGoal + '\t' +
            props.beagleCropCalculation.yieldUnit + '\n' +

            labelBeagleHistoryCard.labelNutrient[langPref] + '\t' +
            labelBeagleHistoryCard.labelRemoval[langPref] + '\t' +
            props.beagleCropCalculation.nutrientUnit + '\n' +

            getClipboardTextRow('N', props.beagleCropCalculation.nutrient.n) +
            getClipboardTextRow('P\u2082O\u2085', props.beagleCropCalculation.nutrient.p2o5) +
            getClipboardTextRow('K\u2082O', props.beagleCropCalculation.nutrient.k2o) +
            getClipboardTextRow('S', props.beagleCropCalculation.nutrient.s) +
            getClipboardTextRow('P', props.beagleCropCalculation.nutrient.p) +
            getClipboardTextRow('K', props.beagleCropCalculation.nutrient.k);
    }

    const actionClipboard = () => {
        navigator.clipboard.writeText(getClipboardContent())
            .then(() => {
                setOpenSnackbar(true);
            })
            .catch(() => {
                console.log('copy to clipboard - failed');
            })
    }


    return (<div>
            <Card className={classes.root}>
                <CardContent>
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                        {props.beagleCropCalculation.cropName[langPref]}
                    </Typography>
                    <Typography variant="h4" component="h2">
                        {props.beagleCropCalculation.yieldGoal}
                    </Typography>
                    <Typography className={classes.pos} color="textSecondary">
                        {props.beagleCropCalculation.yieldUnit}
                    </Typography>
                    <Typography component={'span'}>
                        <BeagleHistoryCardTable
                            beagleLanguagePreference={props.beagleLanguagePreference}
                            beagleCropCalculation={props.beagleCropCalculation}
                        />
                    </Typography>
                </CardContent>
                {
                    hideClearButton ? ('') : (
                        <CardActions>
                            {/*<Button size="small" onClick={handleClearCalc}>{labelClearButton}</Button>*/}
                            {/*<Button className={classes.buttonCopy} size="small" onClick={actionClipboard}>Copy to Clipboard</Button>*/}
                            <Tooltip title={labelCopyButton}>
                                <IconButton aria-label="copy" className={classes.margin} onClick={actionClipboard}>
                                    <FileCopyIcon fontSize="small"/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={labelClearButton}>
                                <IconButton aria-label="remove" className={classes.margin} onClick={handleClearCalc}>
                                    <ClearIcon fontSize="small"/>
                                </IconButton>
                            </Tooltip>


                        </CardActions>

                    )
                }
                <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackbar}>
                    <Alert onClose={handleCloseSnackbar} severity="success">
                        {labelCopySnackBar}
                    </Alert>
                </Snackbar>
            </Card>

        </div>
    );
}
